// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3gyQa","item":"styles_item__2KVoU"};